document.addEventListener('DOMContentLoaded', function () {
  var ALLOWED_POS_VALUES = ['bepoz', 'idealpos', 'swiftpos', 'deliverit', 'ordermate', 'oolio_one'];
  var params = new URLSearchParams(window.location.search);
  var pos = params.get('pos');

  if (pos && ALLOWED_POS_VALUES.indexOf(pos) !== -1) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { pos_product: pos } })
    });
  }
});